import React from 'react';
import PropTypes from 'prop-types';
import without from 'lodash.without';

import { Button, Checkbox } from '../../../../components';
import face1 from '../../../../../img/faces/face_1.png';
import face2 from '../../../../../img/faces/face_2.png';
import face3 from '../../../../../img/faces/face_3.png';
import face4 from '../../../../../img/faces/face_4.png';
import face5 from '../../../../../img/faces/face_5.png';

const Answer = ({ chosenAnswer, answerType, care_quest_answers, onChange }) => {
	if (
		['Multiple Choice Single Select', 'Yes/No', 'scored_slider'].includes(
			answerType
		)
	) {
		return (
			<div>
				{care_quest_answers.map(({ id, answer_text }) => (
					<div key={`${id}`} className="radio c-radio">
						<label>
							<input
								type="radio"
								checked={chosenAnswer === answer_text}
								onChange={() => onChange({ target: { value: answer_text } })}
							/>
							<span className="fa fa-circle" />
							{answer_text}
						</label>
					</div>
				))}
			</div>
		);
	} else if (['Multiple Choice Multiple Select'].includes(answerType)) {
		// checkbox
		return (
			<div>
				{care_quest_answers.map(({ id, answer_text }) => (
					<Checkbox
						key={`${id}`}
						checked={chosenAnswer.includes(answer_text)}
						value={answer_text}
						label={answer_text}
						onChange={({ target }) =>
							onChange({
								target: {
									value: target.checked
										? [answer_text, ...chosenAnswer]
										: without(chosenAnswer, answer_text),
								},
							})
						}
					/>
				))}
			</div>
		);
	} else if (answerType === 'Wellness Scale') {
		return (
			<div className="wellness-scale">
				<Button
					onClick={() => onChange({ target: { value: 1 } })}
					primary={chosenAnswer === 1}
				>
					<img src={face1} alt="Level 1" />
				</Button>
				<Button
					onClick={() => onChange({ target: { value: 2 } })}
					primary={chosenAnswer === 2}
				>
					<img src={face2} alt="Level 2" />
				</Button>
				<Button
					onClick={() => onChange({ target: { value: 3 } })}
					primary={chosenAnswer === 3}
				>
					<img src={face3} alt="Level 3" />
				</Button>
				<Button
					onClick={() => onChange({ target: { value: 4 } })}
					primary={chosenAnswer === 4}
				>
					<img src={face4} alt="Level 4" />
				</Button>
				<Button
					onClick={() => onChange({ target: { value: 5 } })}
					primary={chosenAnswer === 5}
				>
					<img src={face5} alt="Level 5" />
				</Button>
			</div>
		);
	} else if (answerType === 'Date') {
		return (
			<input
				type="date"
				className="form-control"
				onChange={onChange}
				value={chosenAnswer}
			/>
		);
	} else if (answerType === 'Numeric') {
		return (
			<input
				type="number"
				className="form-control"
				onChange={onChange}
				value={chosenAnswer}
			/>
		);
	}
	return (
		<input
			type="text"
			className="form-control"
			onChange={onChange}
			value={chosenAnswer}
		/>
	);
};

Answer.propTypes = {
	chosenAnswer: PropTypes.oneOfType([/*PropTypes.number,*/ PropTypes.string]),
	answerType: PropTypes.string,
	care_quest_answers: PropTypes.array,
	onChange: PropTypes.func,
};

export default Answer;
